// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ZrzVM","requiredAsterisk":"Info_requiredAsterisk__3IVwt"};